// extracted by mini-css-extract-plugin
module.exports = {"imageGroupContainer":"AppBadges-module__imageGroupContainer___22w0G","fluid":"AppBadges-module__fluid___2R0oX"};